var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { HomepageHeroText } from 'src/components/HomepageHeroText/HomepageHeroText';
import HomepageHeroAccordion from '../HomepageHeroAccordion/HomepageHeroAccordion';
import './HomepageHero.scss';
import HomepageHeroHover from '../HomepageHeroHover/HomepageHeroHover';
function HomepageHero(_a) {
    var data = _a.data;
    var HomepageHeroData = data.HomepageHero;
    var _b = useState(window.innerWidth), width = _b[0], setWidth = _b[1];
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(function () {
        window.addEventListener('resize', handleWindowSizeChange);
        return function () {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    var isDesktop = width >= 1220;
    return (_jsxs("main", __assign({ className: "w-screen homepage-hero-container", id: "container-snap-scroller" }, { children: [_jsx(HomepageHeroText, { data: HomepageHeroData }, void 0),
            !isDesktop ? (_jsx(HomepageHeroAccordion, { data: HomepageHeroData }, void 0)) : (_jsx(HomepageHeroHover, { data: HomepageHeroData }, void 0))] }), void 0));
}
export default HomepageHero;
